import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import '../css/Register.css';
import Vas from '../Vas';

import { SetRequired,CheckFields } from 'utils-lib';

import { TextField, ExtendedButton,MessageBox,Checkbox,Loading,  EmailRepeatComponent, HoneyPot } from 'component-lib';

import { RequestAjaxClass, AccountsModel } from 'models-lib';

var moment = require('moment');
moment().format();

class RegisterFKV extends Component {
    
    constructor(props)
    {
        super(props);
        this.state = {};
         this.state.Note1 = '';

        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)}, null);
        this.AccountsModel = new AccountsModel([this], null, this.Request);

        this.requiredEmailRepeat = true;

        Vas.clearLocalStorage();

        this.Config = Vas.Config.RegisterExistingCustomer;
        this.ConfigDataProtection = Vas.Config.DataProtection;

        this.state.RoleId = "";
    }
    
    componentDidMount()
    {
      this.Request.setAuth(false);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      let reqFields = [this.refs.customerId, this.refs.registrationCode];
      let reqCheckBox = [this.refs.AcceptPrivacy,this.refs.AcceptTariffTerms];
      

      this.setState({ requiredFields:reqFields,
                      requiredCeckBox: reqCheckBox},()=>{
                        SetRequired.Set(this.state.requiredFields,null,this.state.requiredCeckBox,null,this.refs.EMailRepeat.returnFields());
                    });

      this.AccountsModel.GetRoles();
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "AccountCreateFKV"){
          Vas.GetView("RegisterSuccess",null,false);
            ReactDOM.unmountComponentAtNode(document.getElementById('messageContainer'));
        }
        else if(observer === "Roles"){
          let result = me.AccountsModel.Roles;
          let id = "";
          for(let i = 0; i< result.length; i++){
            if(result[i].RoleNumber === 5){
              id = result[i].Id;
            }
          }
          this.setState({RoleId:id });
        }
      });
    }
    
    handleChange = (event, index, value) => {
        this.setState({ value });
    }

    Register(){
        let filled = this.checkFields();
        
        if (filled === true){
          
          ReactDOM.render(<Loading modal={true} />,document.getElementById('messageContainer'));
          
          this.AccountsModel.Email = this.refs.EMailRepeat.Email;

          this.AccountsModel.AccountCreateFKV(this.state.RoleId);
            
        }
    }

    //#region checkFields
    checkFields(){
      if(this.refs.HoneyPot.isFilled() === false){
        let filled=false;
      if (this.state.requiredFields && this.state.requiredCeckBox ){
         
          let emailFields = [];
          
          if(this.requiredEmailRepeat === true){
            emailFields = this.refs.EMailRepeat.returnFields();
          }

          filled = CheckFields.CheckFields(this.state.requiredFields,null,this.state.requiredCeckBox,null,emailFields);
          
          if(filled[0] === false){
            if(this.requiredEmailRepeat === true){
              if(this.refs.EMailRepeat.returnFilled()[0] === true){
                if(this.refs.EMailRepeat.state.EmailValid === false){
                  ReactDOM.render(<MessageBox 
                    Message={Vas.Resources.Tooltips["Email"]} 
                    Title={Vas.Resources.Titles["Note"]} />
                      ,document.getElementById('messageContainer'));
                }else{
                  ReactDOM.render(<MessageBox 
                    Message={Vas.Resources.Labels["NotAllFields"]} 
                    Title={Vas.Resources.Titles["Note"]} />
                      ,document.getElementById('messageContainer'));
                }
              }else{
                ReactDOM.render(<MessageBox 
                  Message={Vas.Resources.Labels["NotAllFields"]} 
                  Title={Vas.Resources.Titles["Note"]} />
                    ,document.getElementById('messageContainer'));
              }
            }
            else{
              ReactDOM.render(<MessageBox 
              Message={Vas.Resources.Labels["NotAllFields"]} 
              Title={Vas.Resources.Titles["Note"]} />
                ,document.getElementById('messageContainer'));
            }
          }

          return filled[0]
       }
      }
      
    }

    //#endregion
    
    render()
    {
      
        return (
          <div className={"RegisterExistingCustomerContainer"}>
            <div className={"form registerForm"}>
              <div>
                <h2>{Vas.Resources.Labels["RegisterFKV"]}</h2>
                <div/>
                <div className={"RegisterExistingContainerLeft"} style={{textAlign:'justify'}}>
                    <div><p>{Vas.Resources.Labels["RequiredField"]}</p></div>
                </div>
                <div className={"RegisterExistingContainerLeft"}>
                  <div style={{ color:'red' }}>{this.state.Note1}</div>
                </div>
                <HoneyPot
                    ref={"HoneyPot"}
                  />
                <div>
                  <div className={"RegisterExistingContainerLeft"}>
                    <TextField
                      me={this}
                      Editable={true}
                      IsRequired={true}
                      ref={"customerId"}
                      Id={"customerId"}
                      Label={Vas.Resources.Labels["CustomerNr"]}
                      OnChange={()=>{ this.AccountsModel.CustomerNumber = $("#customerId").val();}} />
                  </div>
                  <div className={"RegisterExistingContainerRight"}>
                    <TextField
                      me={this}
                      Editable={true}
                      IsRequired={true}
                      ref={"registrationCode"}
                      Id={"registrationCode"}
                      Label={Vas.Resources.Labels["RegistrationCode"]}
                      OnChange={()=>{ this.AccountsModel.RegCode = $("#registrationCode").val();}} />
                  </div>
                </div>
                <div>

              </div>
                <div>
                <EmailRepeatComponent
                  AppURL={Vas.ApplicationUrl}
                  ApiUrl={Vas.ApiUrl}
                  ApiKey={Vas.ApiKey}
                  ref={"EMailRepeat"}
                  Required = {this.requiredEmailRepeat}
                  ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
                  IconId={"EmailRepeatIcon"} />
                </div>

                <div className={"RegisterExistingNoteEmailContainerLeft"} style={{ textAlign:"justify"}}>
                  <div id={"noteEmail"}>
                    <b>{Vas.Resources.Titles["Note"]}:</b> {Vas.Resources.Labels["NoteEmail"]}
                  </div>
                </div>

                

                <div>
                  <div className={"RegisterExistingAGBContainerLeft"} style={{ textAlign:'left' }}>
                  <Checkbox
                    ref={"AcceptPrivacy"}
                    Id={"checkboxAcceptPrivacy"}
                    onClick={()=>{this.setState({ AcceptPrivacys:$("#acceptPrivacy").val() });}} />
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptPrivacy"]}*</div>
                  </div>
                </div>
                <div >
                  <div className={"RegisterExistingContainerLeft"}>
                  <ExtendedButton 
                        Usable={true} 
                        Text={Vas.Resources.Labels["ViewHere"]} 
                        OnClick={()=>{ window.open(Vas.ApplicationUrl+"/20_10_16_Hinweise_zur_Datenverarbeitung_und_zum_Datenschutz.pdf"); }} 
                        Id={"btoAcceptPrivacy"}
                        Width={170} />
                  </div>
                </div>
                <div className={"RegisterExistingAGBContainerLeft"} style={{ textAlign:'left' }}>
                  <Checkbox
                    ref={"AcceptTariffTerms"}
                    Id={"checkboxAcceptTariffTerms"}
                    onClick={()=>{this.setState({ AcceptTariffTerms:$("#acceptTariffTerms").val() });}} />
                    <div className={"ConfirmationLabel"}>{Vas.Resources.Labels["AcceptTariffTerms"]}*</div>
                </div>
              </div>
              <div >
                <div className={"RegisterExistingContainerLeft"} style={{ height:'56px' }}>
                <ExtendedButton 
                      Usable={true} 
                      Text={Vas.Resources.Labels["ViewHere"]} 
                      OnClick={()=>{ window.open(this.ConfigDataProtection.LinkTarifBestimmungen); }} 
                      Id={"btoAcceptTariffTerms"}
                      Width={170} />
                      <br />
                </div>
              </div>
              <div>
                <div className={"RegisterExistingContainerLeft"}>
                  <ExtendedButton
                  Id={"registerButtonFkv"}
                  className={"registerButton"}
                  Width={188}
                  Usable={true}
                  Text={Vas.Resources.Labels["Create"]}
                  OnClick={()=>{ this.Register();}}
                  style={{ margin: 25 }} />
                </div>
                <div className={"RegisterExistingContainerRight"}>
                  <ExtendedButton
                  Id={"cancelButtonFkv"}
                  Width={186}
                  Usable={true}
                  Text={Vas.Resources.Labels["Cancel"]}
                  OnClick={()=>{ Vas.GetView("Home",null, false);}}
                  style={{ margin: 25 }} />
                </div>
              </div>
            
              <div id={"fields"}></div>
            </div>
          </div>
          
        );
    }
}
export default RegisterFKV;
